import { render } from "./Credits.vue?vue&type=template&id=131fbbf4"
import script from "./Credits.vue?vue&type=script&lang=js"
export * from "./Credits.vue?vue&type=script&lang=js"
script.render = render

export default script